import React from "react";
import { Button } from "@material-ui/core";
import BusSeats from "./BusSeats";
import { useSelector } from "react-redux";

const BusSection = (props) => {
  const [isCollapsed, setIsCollapsed] = React.useState(true);

  let { state } = useSelector((state) => ({
    state: state.search,
  }));
  const classSeatColorHandler = (obj) => {
    switch (obj.classTitle) {
      case "A":
        return "orange";

      case "B":
        return "#009EE0";

      case "C":
        return "black";
      default:
        break;
    }
  };

  return (
    <div
      className="container-fluid dg1-border p-5 my-4"
      style={{ backgroundColor: "rgb(236 240 249)", borderRadius: "13px" }}
    >
      <div className="d-md-flex d-block justify-content-between">
        <div className="col-md-6 d-none d-md-flex align-items-center">
          <span className="mx-3" style={{ whiteSpace: "nowrap", fontSize: 15 }}>
            {state.travelDetails?.townshipsInfo?.sourceTownshipTitle}
          </span>
          <div className="d-flex align-items-center">
            {" "}
            <i className="fa fa-circle" style={{ color: "gray" }}></i>
            <div className="line" style={{ marginBottom: "auto" }}></div>
            <i className="fa fa-circle" style={{ color: "black" }}></i>
          </div>
          <span className="mx-3" style={{ whiteSpace: "nowrap", fontSize: 15 }}>
            {state.travelDetails?.townshipsInfo?.destTownshipTitle}
          </span>
        </div>

        <div className="col-sm-12 col-md-4 col-lg-3 d-flex justify-content-end">
          <Button
            style={{ borderRadius: "13px", height: "4rem" }}
            className="w-100 bg-warning d-flex align-items-center justify-content-between px-4"
            onClick={() => setIsCollapsed(!isCollapsed)}
          >
            <h6 className="my-auto text-white mx-auto">
              <b>انتخاب صندلی</b>
            </h6>
            <i className="fa fa-arrow-down ml-3 text-white my-auto"></i>
          </Button>
        </div>
      </div>
      <div
        className="d-block d-lg-flex"
        style={{
          display: isCollapsed ? "block" : "none",
          marginBlock: isCollapsed ? "25px 10px" : "0px",
        }}
      >
        <div
          className="col-sm-12  col-lg-9"
          style={{ display: isCollapsed ? "block" : "none" }}
        >
          <div
            className="d-md-flex d-block py-2 justify-content-between"
            style={{
              borderBlock: "1px solid darkgray ",
              opacity: "0.8",
            }}
          >
            {state.travelDetails.length !== 0 ? (
              <>
                {state.travelDetails?.tripPrice.length === 1 ? (
                  <div
                    className="d-flex align-items-center my-5"
                    style={{ gap: 5 }}
                  >
                    {" "}
                    <div
                      className="rounded"
                      style={{
                        width: 30,
                        height: 30,
                        border: `1px solid ${classSeatColorHandler(
                          state.travelDetails?.tripPrice[0]
                        )}`,
                        color: `${classSeatColorHandler(
                          state.travelDetails?.tripPrice[0]
                        )}`,
                        gap: 10,
                      }}
                    >
                      <h4 className="my-auto"></h4>
                    </div>
                    <div className="d-block p-0">
                      <h6 className="p-1 mx-auto my-auto">قیمت هر بلیط</h6>
                      <h5 className="p-1 mx-auto my-auto">
                        {
                          // state.travelDetails?.tripPrice[0].seatPrice
                          state.dynamicPrice
                            ? state.dynamicPrice.toLocaleString('ar-EG')
                            : "دریافت نشد"}{" "}
                        ریال
                      </h5>
                    </div>
                  </div>
                ) : (
                  state.travelDetails?.tripPrice.map((el) => {
                    return (
                      <div
                        className="d-flex rounded align-items-center  my-5"
                        style={{ gap: 5 }}
                      >
                        {" "}
                        <div
                          className="  bg-white rounded d-flex justify-content-center align-items-center "
                          style={{
                            width: 40,
                            height: 40,
                            border: `1px solid ${classSeatColorHandler(el)}`,
                            color: `${classSeatColorHandler(el)}`,
                          }}
                        >
                          <h4 className="my-auto">
                            <b>{el.classTitle}</b>
                          </h4>
                        </div>
                        <div className="d-block">
                          <h6>صندلی کلاس {el.classTitle}</h6>
                          <h5>
                            {el.seatPrice ? el.seatPrice.toLocaleString('ar-EG') : "دریافت نشد"} ریال
                          </h5>
                        </div>
                      </div>
                    );
                  })
                )}
              </>
            ) : null}
          </div>
          <div className=" my-3">
            <div className="d-flex my-5 flex-wrap" style={{ gap: 20 }}>
              <div className="d-flex align-items-center" style={{ gap: 5 }}>
                <div
                  style={{
                    width: 30,
                    height: 30,
                    borderRadius: 7,
                    backgroundColor: "#a7ffa7",
                    border: "2px solid rgb(6 212 51)",
                  }}
                ></div>
                <h6
                  style={{
                    alignSelf: "flex-end",
                    marginRight: 5,
                    whiteSpace: "nowrap",
                  }}
                >
                  انتخاب شما
                </h6>
              </div>
              <div className="d-flex align-items-center" style={{ gap: 5 }}>
                <div
                  style={{
                    width: 30,
                    height: 30,
                    borderRadius: 7,
                    backgroundColor: "darkgray",
                    border: "2px solid gray",
                  }}
                ></div>
                <h6
                  style={{
                    alignSelf: "flex-end",
                    marginRight: 5,
                    whiteSpace: "nowrap",
                  }}
                >
                  انتخاب شده
                </h6>
              </div>
            </div>
            <div className="mt-8 d-none d-lg-block">
              <ul>
                <li className="my-5">
                  <h5 style={{ lineHeight: "30px" }}>
                    صندلی‌های مورد نظر خود را انتخاب کنید.
                  </h5>
                </li>
                <li className="my-5">
                  <h5 style={{ lineHeight: "30px" }}>
                    {" "}
                    لطفا برای انتخاب صندلی بیشتر به صفحه جستجو بازگشته و تعداد نفرات را افزایش دهید.
                  </h5>
                </li>
                <li className="my-5">
                  <h5 style={{ lineHeight: "30px" }}>
                    {" "}
                    صندلی ها با اولین کلیک انتخاب و با کلیک بعدی از انتخاب خارج
                    می‌شود.
                  </h5>
                </li>
              </ul>
            </div>
          </div>
          {/* <div
            className="bg-white w-100 shadow-sm d-none d-lg-flex p-5"
            style={{ borderRadius: 13, marginTop: "15%" }}
          >
            <div style={{ width: 50 }}>
              <Announcement style={{ fontSize: 30, color: "orange" }} />
            </div>
            <h4 style={{ opacity: "0.80" }}>
              <b>
                {" "}
                صندلی ها بر حسب کلاس بندی و همچنین زمان خرید میتوانند قیمت های
                متفاوت داشته باشند
              </b>
            </h4>
          </div> */}
        </div>

        <div
          className="col-sm-12 col-md-6 col-lg-3 mx-auto"
          style={{ display: isCollapsed ? "block" : "none" }}
        >
          <BusSeats />
        </div>
      </div>
    </div>
  );
};

export default BusSection;
